import React, { useEffect, useState } from 'react'
import { Container, Form, Tabs, Tab, Button, Row, Col } from 'react-bootstrap'
import { CATEGORIES_COLLECTION, serverTimestamp } from '../../firebase'
import { useParams } from 'react-router';
import { useHistory } from "react-router-dom";
import urlSlug from 'url-slug'

const INITIAL_STATE = {
    category: '',
    date: serverTimestamp.now(),
    title_en: '',
    title_sr: ''
}

const EditCategory = () => {

    const { id } = useParams()

    const history = useHistory()

    const [edit, setEdit] = useState(INITIAL_STATE)

    const handleEdit = async (e) => {

        e.preventDefault();

        await CATEGORIES_COLLECTION.doc(id).set({
            _id: id,
            category: urlSlug(edit.title_en),
            date: edit.date,
            title_en: edit.title_en,
            title_sr: edit.title_sr
        })
            .then(() => {
                alert("Uspješno uređeno 👍")
                history.push('/preview-category')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    useEffect(() => {

        const getItems = async () => {
            const snapshot = await CATEGORIES_COLLECTION.where('_id', '==', id).get()
            snapshot.forEach(doc => {
                setEdit(doc.data())
            })
        }

        getItems()

    }, []);

    return (
        <>
            <Container>
                <Tabs defaultActiveKey="edit-category" className="mb-3" transition={false}>
                    <Tab eventKey="preview-category" title={<div onClick={() => history.push('/preview-category')}>Pregled kategorija</div>} />
                    <Tab eventKey="add-category" title={<div onClick={() => history.push('/add-category')}>Dodaj</div>} />
                    <Tab eventKey="edit-category" title="Uredi">
                        <Form onSubmit={handleEdit}>
                            <Row>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Naslov (EN)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Naslov (EN)"
                                            value={edit.title_en}
                                            onChange={(e) => { setEdit({ ...edit, title_en: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Naslov (SR)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Naslov (SR)"
                                            value={edit.title_sr}
                                            onChange={(e) => { setEdit({ ...edit, title_sr: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Button variant="primary" type="submit">
                                        Uredi
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Tab>
                    <Tab eventKey="delete-category" title='Obriši' disabled />
                </Tabs>
            </Container>
        </>
    )
}

export default EditCategory
